import { Skeleton } from '@talentmesh/ui/components/skeleton';
import CriteriaFieldLabel, { CriteriaFieldLabelProps } from './CriteriaFieldLabel';
import CriteriaTextAreaInput, { CriteriaTextAreaInputProps } from './CriteriaTextAreaInput';

interface CriteriaFieldProps extends CriteriaFieldLabelProps, CriteriaTextAreaInputProps {
    showDeleteButton: boolean;
}

const CriteriaField = ({ index, disabled, name, onRemove, showDeleteButton }: CriteriaFieldProps) => {
    // Ties the "Criteria N" heading to the textarea so the input exposes it as its accessible name.
    const labelId = `criteria-label-${index}`;

    return (
        <div className="flex flex-col gap-2.5">
            <CriteriaFieldLabel
                labelId={labelId}
                index={index}
                disabled={disabled || !name}
                onRemove={onRemove}
                showDeleteButton={showDeleteButton}
            />
            {name ? (
                <CriteriaTextAreaInput disabled={disabled} name={name} labelId={labelId} />
            ) : (
                <div className="bg-card flex flex-col gap-1 rounded-lg p-1">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                </div>
            )}
        </div>
    );
};

export default CriteriaField;
